<template>
    <b-container fluid class="mt--7">
        <b-card title="Create Service Request">
            <b-card-body>
                <b-form @submit.stop.prevent="createOrder" ref="customerForm">
                    <b-form-group
                        id="input-group-type"
                        label="Type:"
                        label-for="input-type"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-type"
                            v-model="model.order_type_id"
                            :options="orderTypes | mapOptions"
                            required
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled
                                    >Select Order Type</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-category"
                        label="Category:"
                        label-for="input-category"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-category"
                            v-model="model.request_category_id"
                            :options="categories | mapOptions"
                            required
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >Select Category If
                                    Applicable</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-description"
                        label="Description:"
                        label-for="input-description"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-textarea
                            id="input-description"
                            v-model="model.description"
                            placeholder="Brief description of order..."
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group
                        id="input-group-date"
                        label="Due Date:"
                        label-for="input-date"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-date"
                            v-model="model.date"
                            type="date"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-time"
                        label="Due Time:"
                        label-for="input-time"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-time"
                            v-model="model.time"
                            type="time"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="location-group"
                        label=" Service Location"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <location-section
                            ref="locationSection"
                            v-model="model.delivery_location_section_id"
                            @update-section-model="updateLocationSection"
                            :hide-controls="true"
                            title="Service Location"
                            modal-title="Service Location"
                            :is-modal="true"
                        >
                            <b-button
                                @click="$refs.locationSection.setSearchMode()"
                                variant="secondary"
                                style="margin-right: 5px"
                                >Change Location</b-button
                            >
                            <b-button
                                class="mr-2"
                                variant="warning"
                                @click="$refs.locationSection.hideModal()"
                                >Cancel</b-button
                            >
                        </location-section>
                    </b-form-group>

                    <b-form-group
                        id="input-group-note"
                        label="Comments:"
                        label-for="input-note"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-textarea
                            id="input-note"
                            v-model="model.note"
                            placeholder="Enter Comments..."
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group
                        id="input-group-Images"
                        label="Images:"
                        label-for="input-Images"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <ManageAttachments
                            v-model="isModalVisible"
                            :attachments="model.attachments"
                            @update-attachments="updateAttachments"
                        />
                    </b-form-group>

                    <div class="text-right">
                        <b-button
                            style="margin-right: 5px"
                            class="my-4"
                            variant="success"
                            @click="isModalVisible = !isModalVisible"
                            >Upload Images</b-button
                        >
                        <b-button
                            type="submit"
                            class="my-4"
                            variant="primary"
                            :disabled="submitting ? true : false"
                            >Submit</b-button
                        >
                    </div>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import orderHelperMixins from '@/mixins/orderHelperMixins'
import popupMixins from '@/mixins/popupMixins'
import LocationSection from '@/views/Location/LocationSection'
import ManageAttachments from './ManageAttachments.vue'

const scheduledDate = new Date(Date.now() + 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
const scheduledTime = '09:30:00'

export default {
    name: 'create-order-form',
    components: { LocationSection, ManageAttachments },
    mixins: [popupMixins, orderHelperMixins],
    props: [],
    data: () => {
        return {
            isModalVisible: false,

            model: {
                order_type_id: null,
                request_category_id: null,
                description: null,
                date: scheduledDate,
                time: scheduledTime,
                signature: false,
                delivery_location_section_id: null,
                attachments: [],
                note: null,
            },

            hasErrors: false,
        }
    },
    filters: {
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('requestCategory/fetchAll')
        this.model.date = scheduledDate
        console.log('scheduledDate', scheduledDate)
    },
    mounted() {
        this.model.delivery_location_section_id =
            this.customer && this.customer.location_section_id
    },
    computed: {
        submitting() {
            return this.$store.state.customerPortal.loading
        },
        customer() {
            return this.$store.state.customerPortal.customer
        },
        orderTypes() {
            let orderTypes = this.$store.state.orderType.items

            orderTypes = orderTypes
                .filter(x => !!x.is_customer_portal_visible)
                .map(x => ({
                    id: x.id,
                    name: x.customer_portal_name,
                }))
            console.log('orderTypes', orderTypes)
            return orderTypes
        },
        categories() {
            const categories = this.$store.state.requestCategory.categories
            console.log('categories', categories)
            return categories
        },
    },
    watch: {},
    methods: {
        updateAttachments(evt) {
            this.model.attachments.splice(0)
            for (let attachment of evt) {
                this.model.attachments.push(attachment)
            }
        },
        async createOrder() {
            try {
                const model = { ...this.model }

                if (!model.order_type_id)
                    throw new Error('Order Type Must Be selected')

                /*  if (!model.request_category_id)
                    throw new Error('Request Category Must Be selected') */

                model.schedule_at = this.getScheduleAt(model.date, model.time)

                console.log('model', model)
                const valid = await this.$validator.validate()
                if (!valid) {
                    throw new Error('Invalid Entry!!')
                }

                const data = await this.$store.dispatch(
                    'customerPortal/createOrder',
                    model
                )
                this.doToast('Success', 'Order Request Created!', 'success')

                console.log(data)
                // this.$emit('success', data)

                this.$refs.customerForm.reset()
                this.$router.push('/customer-portal/service-requests')
            } catch (err) {
                console.log(err)
                this.doToast('Invalid', err.message, 'danger')
            }
        },
        updateLocationSection(locationData) {
            locationData = locationData || {}
            for (const key in locationData) {
                this.$set(this.model, key, locationData[key])
            }
        },
    },
}
</script>
